import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import type { ToolUsed } from "@/lib/types";
import { cn } from "@/lib/utils";

type ToolsUsedPanelProps = {
  tools: ToolUsed[];
};

export function ToolsUsedPanel({ tools }: ToolsUsedPanelProps) {
  const [open, setOpen] = useState(false);

  if (!tools.length) return null;

  return (
    <div className="mt-2 rounded-md border border-border/60 bg-muted/40 text-xs">
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className="flex w-full items-center gap-1.5 px-3 py-2 text-left font-medium text-muted-foreground hover:text-foreground"
      >
        {open ? (
          <ChevronDown className="size-3.5 shrink-0" />
        ) : (
          <ChevronRight className="size-3.5 shrink-0" />
        )}
        Tools used ({tools.length})
      </button>
      {open && (
        <div className="space-y-2 border-t border-border/60 px-3 py-2">
          {tools.map((tool, index) => (
            <div
              key={`${tool.name}-${index}`}
              className={cn(
                "rounded border border-border/50 bg-background/80 p-2 font-mono"
              )}
            >
              <div className="font-semibold text-foreground">{tool.name}</div>
              <pre className="mt-1 overflow-x-auto whitespace-pre-wrap break-words text-muted-foreground">
                {JSON.stringify(tool.arguments, null, 2)}
              </pre>
              <div className="mt-1 flex flex-wrap gap-3 text-muted-foreground">
                {tool.row_count !== undefined && (
                  <span>rows: {tool.row_count}</span>
                )}
                {tool.duration_ms !== undefined && (
                  <span>{tool.duration_ms} ms</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
